
import React from "react";
import { Checkbox } from "@/components/ui/checkbox";
import { Switch } from "@/components/ui/switch";
import { Market } from "./marketData";

interface MarketItemProps {
  market: Market;
  isSelected: boolean;
  isDefault: boolean;
  isActive: boolean;
  onCheckboxChange: (country: string, checked: boolean) => void;
  onDefaultChange: (country: string, checked: boolean) => void;
  onActiveChange: (country: string, checked: boolean) => void;
}

export const MarketItem: React.FC<MarketItemProps> = ({
  market,
  isSelected,
  isDefault,
  isActive,
  onCheckboxChange,
  onDefaultChange,
  onActiveChange,
}) => {
  return (
    <div 
      key={market.country} 
      className="flex items-center justify-between py-3 border-b border-gray-200 dark:border-gray-700"
    >
      <div className="grid grid-cols-4 gap-2 w-full items-center">
        <div className="flex items-center">
          <Checkbox 
            id={`market-${market.code}`}
            checked={isSelected}
            onCheckedChange={(checked) => 
              onCheckboxChange(market.country, checked as boolean)
            }
          />
        </div>
        <div className="flex items-center gap-2">
          {market.flagComponent}
          <label 
            htmlFor={`market-${market.code}`}
            className="text-sm font-medium text-gray-700 dark:text-gray-300"
          >
            {market.country}
            <span className="ml-1 text-xs font-normal text-gray-500">({market.currency})</span>
          </label>
        </div>
        <div className="flex justify-center">
          {isSelected && (
            <Checkbox 
              id={`default-${market.code}`}
              checked={isDefault}
              onCheckedChange={(checked) => 
                onDefaultChange(market.country, checked as boolean)
              }
            />
          )}
        </div>
        <div className="flex justify-center">
          {isSelected && (
            <Switch
              id={`active-${market.code}`}
              checked={isActive}
              onCheckedChange={(checked) => 
                onActiveChange(market.country, checked as boolean)
              }
            />
          )}
        </div>
      </div>
    </div>
  );
};
